import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class ResultItem extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene, x, y, str, iscorrect) {
    super(scene, x, y);

    this.isCorrect = iscorrect;
    this.txt = ABCyaPhaser.Text.addText(0,0, 22, 0x000000, FontKeys._Comic_Sans_MS, str, this, false).setOrigin(0);
    const markImage = iscorrect ? UIAssetKeys._mm_assets_CorrectMark : UIAssetKeys._mm_assets_IncorrectaMark;

    this.mark = ABCyaPhaser.Images.addImage(0,0, markImage, this).setOrigin(0);

    if (iscorrect) {
      this.mark.x = this.txt.width;
      this.mark.y = 0;
    }
    else {
      this.mark.x = this.txt.width + 5;
      this.mark.y = 5;
    }

    this.mark.alpha = 0;
  }

  getTextWidth () {
    return this.txt.width;
  }

  setMarkX (value) {
    // eslint-disable-next-line no-param-reassign
    if (!this.isCorrect) value += 5;
    // eslint-disable-next-line no-param-reassign
    value += 7; // Buffers
    this.mark.x = value;
  }

  showMark (waiterTime) {
    ABCyaPhaser.Tweens.addTween(this.mark, 400, { alpha: 1,
      delay: waiterTime,
      onStart: () => {
        const soundname = this.isCorrect ? SoundAssetKeys._CorrectMark : SoundAssetKeys._IncorrectMark;
        ABCyaPhaser.Audio.playOneShot(soundname, this.scene);
      } });
  }
}